import { z } from "zod";

export const GetExecutedReportGroupsInputSchema = z.object({
    reportHistoryId: z.string(),
    userName: z.string().nullable().default(null),
});

export type GetExecutedReportGroupsInput = z.infer<typeof GetExecutedReportGroupsInputSchema>;